// src/utils/useIsMobile.ts
//
// Úzká obrazovka (telefon) – se změnou velikosti a otočením zařízení
// (obrazovka rozhodčího dřív počítala šířku jen při vykreslení, otočení
// tabletu se projevilo až s dalším snímkem dat).

import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768): boolean {
  const [mobile, setMobile] = useState<boolean>(() => typeof window !== "undefined" && window.innerWidth < breakpoint);
  useEffect(() => {
    const update = () => setMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    update();
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, [breakpoint]);
  return mobile;
}
